import { render, staticRenderFns } from "./vcurrencyfield.vue?vue&type=template&id=0a91cf16&scoped=true&"
import script from "./vcurrencyfield.vue?vue&type=script&lang=js&"
export * from "./vcurrencyfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a91cf16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
